const MuiTypography = {
  defaultProps: {
    variantMapping: {
      chipLabel: 'div',
      body1Bold: 'p',
    },
  },
} as const;

export default MuiTypography;
